export type MergeSuggestionDto = {
  id: string; // uuid
  sourceId: string; // uuid
  targetId: string; // uuid
  type: 'SERIES' | 'AGENT' | 'WORK';
  processed?: boolean;
  created?: number; // int64
  modified?: number; // int64
  description?: string;
};
export type MergeSuggestion = MergeSuggestionDto;
export type MergeSuggestionType = MergeSuggestionDto['type'];
export const ActiveMergeSuggestionTypes: MergeSuggestionType[] = [
  'SERIES',
  'AGENT',
];

export type MergeSuggestionQueueItem = {
  link: string;
  tooltip: string;
};

export type MergeSuggestionQueueState = MergeSuggestionQueueItem[];
